import { BaseEntity } from 'bookraw/shared/models/base-entity';
import { Partner } from 'bookraw/shared/models/partner.model';

export enum AuthType {
  TOKEN = 'token',
  CODE = 'code'
}

export enum Type {
  VCLOUD = 'vcloud',
  CLASSLINK = 'classlink',
  PLURAL = 'plural',
  CLASSERA = 'classera',
  GG4L = 'gg4l',
  MACMILLAN = 'macmillan',
  BOOKR_CLASS = 'bookrClass',
  ESE = 'ese'
}

export enum Method {
  GET = 'get',
  POST = 'post'
}

export enum AdditionalDataLocation {
  QUERY = 'query',
  BODY = 'body'
}

export enum Sync {
  SIMPLE = 'simple',
  PLURAL_SYNC = 'pluralSync',
  CLASSERA_SYNC = 'classeraSync'
}

export class SsoSetting extends BaseEntity {
  ssoId: string;
  partner: Partner;

  type: Type;
  authType: AuthType;
  validationUrl: string;
  validationMethod: Method;

  userInfoUrl: string;
  userInfoMethod: Method;

  redirectUrl: string;

  additionalHeaders: KeyValue[];
  additionalBody: KeyValue[];
  additionalBodyLocation: AdditionalDataLocation;
  tokenParameterName: string;

  syncMethod: Sync;
  clientSecret: string;

  isOfflineAvailable: boolean;
  isAudioEnabled: boolean;
  isViewRestricted: boolean;
  isStayLoggedIn: boolean;
}

class KeyValue {
  key: string;
  value: string;
}

export class SsoState extends BaseEntity {
  locale?: string;
  message?: string;
  result?: string | object;
}
